import React, { useCallback, useState } from "react"

import { paymentClient, useQuery } from "@trueskin-web/apis"

import { usePaymentContext } from "../../payment.context"

export const usePaypalClientToken = ({ order }) => {
  const { amount } = order

  const intent = amount ? "capture" : "tokenize"

  const {
    data: { clientToken: braintreeClientToken } = {},
    isLoading: isBraintreeClientTokenLoading,
  } = useQuery(
    ["braintreeClientToken", order?.orderId],
    paymentClient.createBraintreePaymentSession,
    {
      enabled: !!order?.orderId,
    }
  )

  return { intent, braintreeClientToken, isBraintreeClientTokenLoading }
}

export const usePaypal = ({ paymentMethodType, order }) => {
  const { amount, currency, customerId, v2CustomerId, accountId } = order
  const { handlePurchase, onError } = usePaymentContext()

  const [error, setError] = useState()

  const handleError = useCallback(
    ({ data: { refusalReasonCode } = {} }) => {
      setError(refusalReasonCode)

      onError?.({ paymentMethodType, order, refusalReasonCode })
    },
    [onError, paymentMethodType, order]
  )

  const handleCreateOrder = useCallback(
    (data, actions) =>
      actions.braintree.createPayment({
        amount,
        currency,
        requestBillingAgreement: true,
        flow: "checkout",
        intent: "capture",
      }),
    [amount, currency]
  )

  const handleCreateBillingAgreement = useCallback(
    (data, actions) =>
      actions.braintree.createPayment({
        flow: "vault",
      }),
    []
  )

  const handleApprove = useCallback(
    async (data, actions) => {
      setError(null)

      return handlePurchase({
        provider: "braintree",
        currency,
        paymentMethod: {
          nonce: (await actions.braintree.tokenizePayment(data)).nonce,
          amount,
          currency,
        },
        customerId,
        v2CustomerId,
        accountId,
      }).then(({ data }) => data)
    },
    [amount, currency, customerId, v2CustomerId, accountId, handlePurchase]
  )

  const handleCancel = useCallback(() => {
    // no-op
  }, [])

  return React.useMemo(() => {
    return {
      // intent,
      // braintreeClientToken,
      // isBraintreeClientTokenLoading,
      handleCreateBillingAgreement,
      handleCreateOrder,
      handleApprove,
      handleCancel,
      error,
      handleError,
    }
  }, [
    // intent,
    // braintreeClientToken,
    // isBraintreeClientTokenLoading,
    handleCreateBillingAgreement,
    handleCreateOrder,
    handleApprove,
    handleCancel,
    error,
    handleError,
  ])
}
